module.exports = __webpack_public_path__ + "img/DiasDeGrabacion.f5b5d736.svg";